var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTagLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66646 2.30658L2.62556 3.31477L1.61738 8.35567C1.60123 8.43639 1.60527 8.51984 1.62912 8.59862C1.65297 8.6774 1.69591 8.74908 1.75411 8.80728L8.28241 15.3356C8.32884 15.382 8.38396 15.4188 8.44462 15.444C8.50529 15.4691 8.5703 15.482 8.63596 15.482C8.70163 15.482 8.76664 15.4691 8.82731 15.444C8.88797 15.4188 8.94309 15.382 8.98952 15.3356L14.6464 9.67873C14.6928 9.6323 14.7296 9.57718 14.7548 9.51652C14.7799 9.45585 14.7928 9.39083 14.7928 9.32517C14.7928 9.25951 14.7799 9.19449 14.7548 9.13383C14.7296 9.07317 14.6928 9.01805 14.6464 8.97162L8.11807 2.44332C8.05987 2.38512 7.98819 2.34218 7.90941 2.31833C7.83063 2.29448 7.74718 2.29044 7.66646 2.30658V2.30658Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.6875C5.66421 6.6875 6 6.35171 6 5.9375C6 5.52329 5.66421 5.1875 5.25 5.1875C4.83579 5.1875 4.5 5.52329 4.5 5.9375C4.5 6.35171 4.83579 6.6875 5.25 6.6875Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagLeft);
export default __webpack_public_path__ + "static/media/Tag_left.5f1bb2f7238dd00502d8ea10e93448bd.svg";
export { ForwardRef as ReactComponent };